exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xm-invoice[data-v-5993c81c]{padding:20px}.xm-invoice .need-red-invoice-link[data-v-5993c81c],.xm-invoice .operator-link[data-v-5993c81c]{cursor:pointer}.xm-invoice h2[data-v-5993c81c]{margin-bottom:16px;font-size:20px;font-weight:600;color:#333}.xm-invoice[data-v-5993c81c] .mm-tfixed__right .mm-tbody table{min-width:205px}", ""]);

// exports
